import { CodeBlock } from '@awell/ui-kit/components/CodeBlocks'
import React from 'react'

interface Props {
  outputs?: string
}

export const DecisionOutputsTab = ({ outputs }: Props): JSX.Element => {
  return (
    <div className="flex flex-col gap-2">
      <label className="block font-medium text-lg text-slate-600">Decision outputs</label>
      <CodeBlock text={outputs ?? ''} />
    </div>
  )
}

DecisionOutputsTab.displayName = 'DecisionOutputsTab'
